import ToolMenu from '@/features/tool/components/ToolMenu';
import clsx from 'clsx';

const NavbarMobileTools = ({
  toolMenuopen,
  isProBanner,
}: {
  toolMenuopen: boolean;
  isProBanner: boolean;
}) => {
  return (
    <div
      className={clsx(
        'transition-all duration-400 ease-in-out py-4 overflow-auto bg-gray-very-light fixed z-[10000] max-w-screen w-full',
        toolMenuopen
          ? isProBanner
            ? '!max-h-[calc(100dvh-102px)] !h-[calc(100dvh-102px)]'
            : '!max-h-[calc(100dvh-62px)] !h-[calc(100dvh-62px)]'
          : 'max-h-0'
      )}
    >
      <ToolMenu />
    </div>
  );
};

export default NavbarMobileTools;
